RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.ReactWidgetBridge = models.Widget.extend({
        panelView: App.views.ReactWidgetLayout,

        // NOTE override this for seamless details/export views
        getView: function () {
            const me = this;
            return me.panelView;
        }
    });

});
